import React from 'react'
import { Alert } from 'components'
import { CheckMicAndPermissions } from '.'
import { PerformAssessmentContext } from './PerformAssessmentContext'
import { TeacherMicCheckStyles } from './Style'

// פופאפ לבדיקת אודיו למורה משימה z8rp3f66rh,
// במצב isTeacherCheck (טקסט כתוב במקום קריינות, בלי כפתור דלג)
const MicCheckAlert = (props) => {
    const { handleAlert } = props

    const commonValue = {
        setCurrentStep: () => handleAlert(false),
        isMaleGender: true,
        isHighGrade: false,
        isTeacherCheck: true
    }

    return (
        // -sx- מועבר לMUI לשלוט על העיצוב כיוון ששונה פה
        <Alert
            title="בדיקת שמע למורה"
            handleAlert={handleAlert}
            closeIcon={<i className="fa-regular fa-xmark"></i>}
            sx={{
                '& .MuiPaper-root.MuiDialog-paper': {
                    width: 660,
                    maxWidth: 660,
                    // גובה קבוע - לשנות אחרי שתהילה תגדיר בפיגמה
                    height: 437,
                    padding: '24px',
                    boxSizing: 'border-box',
                    border: '1px solid #E8F0F5',
                    borderRadius: '16px',
                    background: 'linear-gradient(5deg, #FFF -48.96%, #E6F0FE 97.86%)',
                    boxShadow: '0 0 31.5px 0 rgba(0,0,0,0.09)'
                },
                '& .dialog-title': {
                    padding: '0 0 12px',
                    borderBottom: '1px solid #FFF',
                    fontSize: 20,
                    color: '#404F69'
                },
                '& .dialog-title .MuiIconButton-root': {
                    padding: 0,
                    fontSize: 20,
                    color: '#325168'
                },
                '& .MuiDialogContent-root': {
                    padding: '16px 0 0 !important',
                    overflow: 'visible',
                    display: 'flex',
                    flexDirection: 'column'
                }
            }}
        >
            <TeacherMicCheckStyles>
                <PerformAssessmentContext.Provider value={commonValue}>
                    <CheckMicAndPermissions />
                </PerformAssessmentContext.Provider>
            </TeacherMicCheckStyles>
        </Alert>
    )
}

export default MicCheckAlert
